import { useState } from 'react'

const useCustomMessageText = ({ onChangeCustomMessage, supportedLanguages, customMessages }) => {
  const [messageErrors, setMessageErrors] = useState({})

  const handleChangeCustomMessage = (data, textLanguage) => {
    onChangeCustomMessage(data.html, textLanguage)
  }

  const handleOnBlurMessage = () => {
    supportedLanguages.forEach(lang => {
      setMessageErrors(errors => ({ ...errors, [lang]: customMessages?.[lang] ? false : true }))
    })
  }

  return {
    handleChangeCustomMessage,
    handleOnBlurMessage,
    messageErrors,
  }
}

export default useCustomMessageText
